import { createApi } from '@reduxjs/toolkit/query/react';
import rtkFetchRequest from '../configs/rtkFetchRequest';

export const ordersApi = createApi({
  reducerPath: 'orders',
  baseQuery: rtkFetchRequest(),
  endpoints: (builder) => ({
    getListPaymentsByOrderIds: builder.query({
      query: (ordersIds) => ({
        method: 'GET',
        endpoint: `/orders/get_list_payment_details`,
        body: { orders_ids: ordersIds },
      }),
    }),
  }),
});

export const { useGetListPaymentsByOrderIdsQuery } = ordersApi;
